// extracted by css-extract-rspack-plugin
export default {"cls1":"CiterightInline-cls1_nm1","cls2":"CiterightInline-cls2_XzS CiterightInline-cls1_nm1"};